import { c as _c } from "react/compiler-runtime";
import { useTheme } from "next-themes";
const useThemeToggle = () => {
  const $ = _c(6);
  const {
    theme,
    setTheme
  } = useTheme();
  let t0;
  if ($[0] !== setTheme || $[1] !== theme) {
    t0 = () => {
      setTheme(theme === "light" ? "dark" : "light");
    };
    $[0] = setTheme;
    $[1] = theme;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const toggleTheme = t0;
  let t1;
  if ($[3] !== theme || $[4] !== toggleTheme) {
    t1 = {
      theme,
      toggleTheme
    };
    $[3] = theme;
    $[4] = toggleTheme;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default useThemeToggle;